<template>
  <div class="temp2-dept-main">
    <div class="search-panel">
      <a-input v-model="queryParam.keyword" class="search-input" placeholder="请输入科室关键字进行查询"></a-input>
      <a-button size="small" @click="loadDataByKeyword()" :disabled="project.confirm === '0'">查询</a-button>
    </div>
    <!-- <div class="temp2-dept-title">
      选择科室
    </div> -->
    <div class="row row2">
      <!-- <div class="row3-item row-item-no" v-if="otherList.length == 0 && keywordList.length == 0">
        暂无科室
      </div>
      <template v-else>
        <div v-for="(item,index) in keywordList" :key="item.id" class="row3-item">
          <div class="row-item-btn" style="color:red">
            <a-icon type="plus"  @click="addDept(item)"/>
          </div>
          <div style="color:red">
            {{item.name}}
          </div>
        </div>
        <div v-for="(item,index) in otherList" :key="item.id" class="row3-item">
          <div class="row-item-btn">
            <a-icon type="plus"  @click="addDept(item)"/>
          </div>
          <div>
            {{item.name}}
          </div>
        </div>
      </template> -->
    </div>
    <div class="temp2-dept-title">
      为您推荐
    </div>
    <div class="row row2">
      <div class="row2-item row-item-no" v-if="keywordList.length == 0">
        暂无推荐
      </div>
      <template v-else>
        <div v-for="(item, index) in keywordList" :key="index" class="row2-item">
          <div class="row-item-btn">
            <a-icon :class="{ 'icon-disabled': project.confirm === '0'}" type="plus" @click="addDept(item)" />
          </div>
          <div>
            {{ item.name }}
          </div>
        </div>
      </template>
    </div>
    <div class="temp2-dept-title">
      其他科室
    </div>
    <div class="row row3">
      <div class="row3-item row-item-no" v-if="otherList.length == 0">
        暂无其他科室
      </div>
      <template v-else>
        <div v-for="(item, index) in otherList" :key="index" class="row3-item">
          <div class="row-item-btn" :disabled="project.confirm === '0'">
            <a-icon :class="{ 'icon-disabled': project.confirm === '0' }" type="plus" @click="addDept(item)" />
          </div>
          <div>
            {{ item.name }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@api/manage'

export default {
  name: 'Dept',
  props: {
    project: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      queryParam: {
        keyword: null,
      },
      keywordList: [],
      otherList: [],
      deptSelectedList: [],
    }
  },
  watch: {
    project() {
      this.handleData()
      // console.log(this.project.projectName || this.project.name)
      this.queryParam = {
        projectName: this.project.projectName || this.project.name,
        keyword: ''
      }
      this.loadData()
    }
  },
  mounted() {
    // this.handleData()
    // this.queryParam = {

    //   projectName:this.project.projectName || this.project.name,
    //   keyword: ''
    // }
    // this.loadData()
  },
  methods: {
    addDept(dept) {
      let has = false
      this.deptSelectedList.forEach(item => {
        if (dept.code == item.code) {
          has = true
        }
      })
      if (has) {
        return this.$message.error('不能重复添加')
      } else {
        // if (this.deptSelectedList.length >= 1) {
        //   let temp=this.deptSelectedList[0]
        //   this.deptSelectedList.length=0
        //   this.deptSelectedList.push(dept)
        //   this.deptSelectedList.push(temp)
        //   return this.$message.error('只能添加1个科室')
        // } else {
        //   this.deptSelectedList.push(dept)
        // }
        this.deptSelectedList = [dept]
        this.submit()
      }
    },
    deleteDept(index) {
      this.$confirm({
        title: '删除科室',
        content: (<div>
          <p>您确定要删除这个科室吗？</p>
        </div>),
        centered: false,
        onOk: () => {
          if (this.deptSelectedList.length >= 2) {
            this.deptSelectedList.splice(index, 1);
            this.submit()
          } else {
            this.$message.warn('至少需要保留一个')
          }
        }
      });
    },
    handleData() {
      if (this.project.deptJson) {
        this.deptSelectedList = JSON.parse(this.project.deptJson)
      }
    },
    loadDataByKeyword() {
      // this.queryParam.projectName = ''
      this.loadData()
    },
    loadData() {
      getAction('/projectconfigview/configDept/list', this.queryParam).then(res => {
        if (res.success) {
          this.keywordList = res.result.keywordList
          this.otherList = res.result.otherList
          if (this.keywordList.length == 0 && this.otherList.length == 0) {
            this.$message.warn('请输入合适的关键字')
          }
        }
      })
    },
    submit() {
      if (this.deptSelectedList.length == 0) {
        return this.$message.error('请选择科室')
      }
      postAction('/projectconfigview/configProject/saveDept', { id: this.project.id, deptJson: JSON.stringify(this.deptSelectedList) }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('submit')
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.temp2-dept-main {
  .search-panel {
    span {
      color: white;
    }

    .search-input {
      width: 400px;
      margin: 0 10px;
      color: white;
      border: 1px solid rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.15);
    }

    margin-bottom: 20px;
  }

  .temp2-dept-title {
    font-size: 18px;
    color: white;
  }

  .row1 {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;

    .row1-item {
      display: inline-table;
      width: 173px;
      height: 76px;
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 10px;
      position: relative;
      font-size: 18px;
      color: white;
      background-color: #376EFF;
    }

  }

  .row-item-btn {
    position: absolute;
    right: 5px;
    top: 0px;
  }

  .icon-disabled {
    pointer-events: none;
    /* 禁用点击事件 */
    opacity: 0;
    /* 改变透明度，使其看起来被禁用 */
  }


  .row2 {
    .row2-item {
      display: inline-table;
      width: 173px;
      height: 77px;
      text-align: center;
      padding-top: 16px;
      padding-bottom: 16px;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 12px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      position: relative;
      font-size: 18px;
      color: white;
      background-color: #284895;
    }

  }

  .row3 {
    display: flex;
    flex-wrap: wrap;

    .row3-item {
      width: 111px;
      height: 52px;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      position: relative;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      background: rgba(255, 255, 255, 0.07);
    }

  }

  .row-item-no {
    border: 1px dashed rgba(0, 0, 0, 0.2) !important;
  }
}
</style>